module.exports = __webpack_public_path__ + "img/serifnew_box01.9529161d.jpg";